import { Controller, CustomArgs, Menu, Toolbar } from '@tencent/workbench';
import { AiGeneratePageFeature } from '@framework/workbench/ui/ai-generate-page/ai-generate-page-feature';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { config, TOOLBAR_CONFIG, MENU_CONFIG } from './config';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

@Controller({
    toolbarItems: TOOLBAR_CONFIG,
    menuItems: MENU_CONFIG,
})
export class AiGeneratePageController {
    constructor(private readonly feature: AiGeneratePageFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    public onClick() {
        this.feature.triggerGeneratePage();
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.PAGE_CREATE,
            action: TDWActionType.AI_CLK,
            ver5: TDWModuleType.PC,
            ver6: '0',
        });
    }

    // 云编文档、本地文档屏蔽掉ai生成页
    @Menu(config.id, 'shouldHide')
    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    public shouldHide(): boolean {
        // 母版编辑下隐藏入口
        const isMasterEditType = !!(AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.masterLayoutEditService.isMasterEditType;
        // ToggleConfig 对 AI-Float 的开关
        const EnabledByToggleConfig = (getToggleStatusByType(ToggleType.AI_FLOAT_BAR) ?? true);
        return !(DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.aiGeneratePage) ?? false)
            || isMasterEditType
            || !EnabledByToggleConfig;
    }
}
